// Getters
export const GET_PERSONGROUPS = "persongroups/GET_PERSONGROUPS";
export const GET_PERSONGROUP = "persongroups/GET_PERSONGROUP";

// Mutations
export const MUTATE_LOAD_PERSONGROUPS = "persongroups/MUTATE_LOAD_PERSONGROUPS";
export const MUTATE_ADD_PERSONGROUP = "persongroups/MUTATE_ADD_PERSONGROUP";
export const MUTATE_UPDATE_PERSONGROUP = "persongroups/MUTATE_UPDATE_PERSONGROUP";
export const MUTATE_DELETE_PERSONGROUP = "persongroups/MUTATE_DELETE_PERSONGROUP";

// Actions
export const ACTION_GET_PERSONGROUPS = "persongroups/ACTION_GET_PERSONGROUPS";
export const ACTION_GET_PERSONGROUP = "persongroups/ACTION_GET_PERSONGROUP";
export const ACTION_ADD_PERSONGROUP = "persongroups/ACTION_ADD_PERSONGROUP";
export const ACTION_UPDATE_PERSONGROUP = "persongroups/ACTION_UPDATE_PERSONGROUP";
export const ACTION_DELETE_PERSONGROUP = "persongroups/ACTION_DELETE_PERSONGROUP";